<div class="padding">
    <div class="padding-bottom-15">
        <mat-checkbox [(ngModel)]="searchByTitleNumber" (change)="onTitleNumberValueChange($event)" class="form-field">
            {{ 'orders.titleNumber2' | transloco }}
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="searchByLegalDescription" (change)="onLegalDescriptionValueChange()"
            class="form-field">
            {{ 'orders.legalDescription2' | transloco }}
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="searchByAddress" (change)="onAddressValueChange()" class="form-field">
            {{ 'orders.civicAddress2' | transloco }}
        </mat-checkbox>
    </div>
    <form [formGroup]="criteria">
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.showTitleNumber) {
        @if(order.jurisdiction === 'MB') {
        <div [@slideDown]="searchByTitleNumber ? 'visible' : 'hidden'">
            <h4 class="margin-bottom-5">{{ 'orders.titleNumber2' | transloco }}</h4>
            <div class="validated-form-field-container flex-container-vertical-center">
                <div class="flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.titleNumber2' | transloco }} </mat-label>
                        <input matInput formControlName="titleNumber1"
                            [maxLength]="uiConfiguration.landTitleSearchCriteriaConfiguration!.titleNumberFirstSegmentMaxLength"
                            name="titleNumber1" [placeholder]="firstSegmentPlaceholder">
                    </mat-form-field>
                </div>
                <span class="padding-right-5"> {{
                    uiConfiguration.landTitleSearchCriteriaConfiguration!.titleNumberSegmentSeparator }} </span>
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'orders.district' | transloco }}</mat-label>
                    <mat-select formControlName="titleNumber2" data-testid="district-dropdown">
                        @for (opt of ['1', '2', '3', '4', '5', '6']; track opt) {
                        <mat-option [value]="opt" data-testid="district" [attr.data-testid]="'district-option-' + opt">
                            {{
                            opt }} </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <lib-error-bubble [message]="titleNumberErrors$"></lib-error-bubble>
            </div>
        </div>
        } @else {
        <div [@slideDown]="searchByTitleNumber ? 'visible' : 'hidden'">
            <h4 class="margin-bottom-5">{{ 'orders.titleNumber2' | transloco }}</h4>
            <div class="validated-form-field-container flex-container-vertical-center">
                @if (uiConfiguration.landTitleSearchCriteriaConfiguration!.titleNumberFirstSegmentMaxLength) {
                <div class="flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ firstSegmentTitle }} </mat-label>
                        <input matInput formControlName="titleNumber1"
                            [maxLength]="$safeNavigationMigration(uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberFirstSegmentMaxLength)"
                            name="titleNumber1" [placeholder]="firstSegmentPlaceholder">
                    </mat-form-field>
                </div>
                }

                @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberSegmentSeparator &&
                uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberSecondSegmentMaxLength) {
                <span>{{ uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberSegmentSeparator }}</span>
                }

                @if (uiConfiguration.landTitleSearchCriteriaConfiguration!.titleNumberSecondSegmentMaxLength) {
                <div class="flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ secondSegmentTitle }} </mat-label>
                        <input matInput formControlName="titleNumber2"
                            [maxLength]="$safeNavigationMigration(uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberSecondSegmentMaxLength)"
                            name="titleNumber2" [placeholder]="secondSegmentPlaceholder">
                    </mat-form-field>
                </div>
                }

                @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberSegmentSeparator &&
                uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberThirdSegmentMaxLength) {
                <span>{{ uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberSegmentSeparator }}</span>
                }

                @if (uiConfiguration.landTitleSearchCriteriaConfiguration!.titleNumberThirdSegmentMaxLength) {
                <div class="flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ secondSegmentTitle }} </mat-label>
                        <input matInput formControlName="titleNumber3"
                            [maxLength]="$safeNavigationMigration(uiConfiguration.landTitleSearchCriteriaConfiguration?.titleNumberThirdSegmentMaxLength)"
                            name="titleNumber3" [placeholder]="thirdSegmentPlaceholder">
                    </mat-form-field>
                </div>
                }

                <lib-error-bubble [message]="titleNumberErrors$"></lib-error-bubble>
            </div>
        </div>
        }
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration!.showLegalDescription) {
        <div [@slideDown]="searchByLegalDescription ? 'visible' : 'hidden'">
            <h4 class="margin-bottom-5">{{ 'orders.legalDescription2' | transloco }}</h4>
            @if
            (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showRuralLegalDescription
            &&
            uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showUrbanLegalDescription)
            {
            <div class="flex-container">
                <div class="flex-item form-field">
                    <mat-radio-group formControlName="legalDescriptionTypeID"
                        [attr.aria-label]="'orders.legalDescriptionTypeRadioOptions' | transloco" (change)="onLegalDescriptionValueChange()">
                        <mat-radio-button class="radio-button" [value]="'Rural'">{{ 'orders.rural' | transloco }}</mat-radio-button>
                        <mat-radio-button class="radio-button" [value]="'Urban'">{{ 'orders.urban' | transloco }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            }
            @if(criteria.get('legalDescriptionTypeID')?.value === 'Rural') {
            <div class="flex-container">
                @if
                (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showLegalSubdivision)
                {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.legalSubdivision2' | transloco }} </mat-label>
                        <input matInput formControlName="legalSubdivision" name="legalSubdivision"
                            [placeholder]="'orders.legalSubdivision2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="legalSubdivisionErrors$"></lib-error-bubble>
                </div>
                }

                @if
                (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showQuarter)
                {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.quarter2' | transloco }} </mat-label>
                        <mat-select formControlName="quarter" data-testid="quarter-dropdown">
                            @for (opt of [ 'NE', 'NW', 'SE', 'SW' ]; track opt) {
                            <mat-option [value]="opt" data-testid="quarter" [attr.data-testid]="'quarter-option-' + opt">
                                {{
                                opt }} </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <lib-error-bubble [message]="quarterErrors$"></lib-error-bubble>
                </div>
                }

                @if
                (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showSection)
                {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.section2' | transloco }} </mat-label>
                        <input matInput formControlName="section" name="section" [placeholder]="'orders.section2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="sectionErrors$"></lib-error-bubble>
                </div>
                }
            </div>
            <div class="flex-container">
                @if
                (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showTownship)
                {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.township2' | transloco }} </mat-label>
                        <input matInput formControlName="township" name="township" [placeholder]="'orders.township2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="townshipErrors$"></lib-error-bubble>
                </div>
                }

                @if
                (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showRange) {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.range2' | transloco }} </mat-label>
                        <input matInput formControlName="range" name="range" [placeholder]="'orders.range2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="rangeErrors$"></lib-error-bubble>
                </div>
                }

                @if
                (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showMeridian)
                {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.meridian2' | transloco }} </mat-label>
                        <input matInput formControlName="meridian" name="meridian" [placeholder]="'orders.meridian2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="meridianErrors$"></lib-error-bubble>
                </div>
                }

                @if
                (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showExtension)
                {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.extension2' | transloco }} </mat-label>
                        <input matInput formControlName="extension" name="extension" [placeholder]="'orders.extension2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="extensionErrors$"></lib-error-bubble>
                </div>
                }
            </div>
            }
            @if(criteria.get('legalDescriptionTypeID')?.value === 'Urban') {
            <div class="flex-container">
                @if(uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showPlan) {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.plan2' | transloco }} </mat-label>
                        <input matInput formControlName="plan" name="plan" [placeholder]="'orders.plan2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="planErrors$"></lib-error-bubble>
                </div>
                }

                @if
                (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showBlockOrUnit)
                {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.blockUnit2' | transloco }} </mat-label>
                        <input matInput formControlName="blockOrUnit" name="blockOrUnit" [placeholder]="'orders.blockUnit2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="blockOrUnitErrors$"></lib-error-bubble>
                </div>
                }

                @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showLot) {
                <div class="validated-form-field-container flex-container flex-item">
                    <mat-form-field class="flex-item form-field" appearance="outline">
                        <mat-label> {{ 'orders.lot2' | transloco }} </mat-label>
                        <input matInput formControlName="lot" name="lot" [placeholder]="'orders.lot2' | transloco">
                    </mat-form-field>
                    <lib-error-bubble [message]="lotErrors$"></lib-error-bubble>
                </div>
                }
            </div>
            }
        </div>
        }
        @if(uiConfiguration.landTitleSearchCriteriaConfiguration?.showAddress) {
        <div [@slideDown]="searchByAddress ? 'visible' : 'hidden'">
            <h4 class="margin-bottom-15">{{ 'orders.civicAddress2' | transloco }}</h4>
            <lib-address-form [staticCountryCode]="order.country" [staticJurisdiction]="order.jurisdiction" [showFormLabel]="false" [uiConfiguration]="$safeNavigationMigration(uiConfiguration.landTitleSearchCriteriaConfiguration?.addressConfiguration)"></lib-address-form>
        </div>
        }
    </form>
</div>